import { useEffect } from 'react';
import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions';
import { dailyAttemptsModal } from '../../../../../constants/copyright-modals';
import { useUser } from '../../../../../redux/reducer/user';
import { MAIN } from '../../../../../constants/shared/states/names';
import { useAppState } from '../../../../../redux/reducer/content';

export default function useHandleTaskComplete() {
  const state = useAppState();
  const { profile } = useUser();
  const { addModal } = useModalsDataActions();

  useEffect(() => {
    if (!profile?.newFreeAttempts || state !== MAIN) return;

    addModal({
      type: 'taskCompleteModal',
      props: {
        ...dailyAttemptsModal,
        attempts: profile.newFreeAttempts,
        isFreeAttempts: true,
      },
    });
  }, [profile?.newFreeAttempts, state]);
}
